import { headlineCurrencyFormatterId } from '../../../../client-customizations/default/formatters';
import { FMT } from '../../../../util/formatter-service';

export const KPIFormatterTypesMap = {
  currency: 'currency',
  multiple: 'multiple',
  percentage: 'percentage',
  number: 'number',
  integer: 'integer',
  numeric: 'numeric',
};

export function format(val: number, type: string): string {
  if (Number.isNaN(val)) {
    return '-';
  }
  switch (type) {
    case KPIFormatterTypesMap.currency:
      return FMT.format(headlineCurrencyFormatterId, val);
    case KPIFormatterTypesMap.multiple:
      return FMT.format('multiplier', val);
    case KPIFormatterTypesMap.percentage:
      return FMT.format('percent', val);
    case KPIFormatterTypesMap.number:
      return FMT.format('numeric', val);
    case KPIFormatterTypesMap.numeric:
      return FMT.format('integer', val);
    case KPIFormatterTypesMap.integer:
      return FMT.format('integer', val);
    default:
      throw new Error('Format: unsupported type');
  }
}
